import {
  AfterViewInit, ChangeDetectionStrategy,
  ChangeDetectorRef,
  Compiler,
  Component, ComponentFactoryResolver,
  Input,
  NgModule,
  OnInit,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {Item} from "../../models/Item";
import {CommonModule} from "@angular/common";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {FormsModule} from "@angular/forms";
import {AbstractMainPlugin} from "../../classes/AbstractMainPlugin";
import {MapObjectPlugin} from "../../classes/plugins/MapObjectPlugin";

@Component({
  selector: 'app-before-item',
  templateUrl: './before-item.component.html',
  styleUrls: ['./before-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BeforeItemComponent implements OnInit, AfterViewInit {

  @Input() item;

  private temp;

  @ViewChild('dynamicComponent', {static: true, read: ViewContainerRef}) vc: ViewContainerRef;

  constructor(private cdr: ChangeDetectorRef, private resolver: ComponentFactoryResolver) {
  }
  ngOnInit() {
    let str = '';
    str += this.item.registeredPlugins.map(plugin => {

      if (plugin.getBeforeItemComponent){
        return plugin.getBeforeItemComponent()
      }
      return null;
    });
    str = str.replace(/,/g, '');
    this.temp = str;

    this.item.config.serverUpdate.subscribe(()=>{
      this.cdr.markForCheck();
    })

    this.item.config.subject.subscribe(()=>{
      this.cdr.markForCheck();
    })
  }

  createComponent(component, item){
    this.vc.clear();
    const factory = this.resolver.resolveComponentFactory(component);
    const componentRef = this.vc.createComponent(factory);
    // @ts-ignore
    componentRef.instance.item = item;
  }

  ngAfterViewInit(): void {

    let self = this;
    const template = this.temp;

    let componentsToAdd = Item.plugins.reduce((acc, plugin) => acc.concat(plugin.getBeforeItemComponents()), []);

    componentsToAdd.forEach((component)=>{
      this.createComponent(component, self.item);
    });
    this.cdr.detectChanges();

  }

}
